export default __webpack_public_path__ + "static/media/element_spec_94.9c502cf7.jpg";